import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ValidationService, StringService} from '../../services';
import {RouteKeys} from '../../constants';
import validationBrazilian from './validationBrazilian';
import validationForeign from './validationForeign';
import {InputText, ScreenNotificationDefault, Footer} from '../../components';
import {
  redirectToEndDataRegistration,
  redirectToDataResidential,
} from '../../ducks/Navigate';
import {
  updateDadosDocumento,
  dadosDocumentoAdicionar,
} from '../../ducks/Customer';
import {orgaosExpedidoresBuscar, ufBuscar} from '../../ducks/Select';

import Select from 'react-select';
import {SelectStyles} from '../../constants';

import './styles.scss';

class DataDocument extends Component {
  formIsValid = () => {
    if (
      this.props.dadosPessoais.nacionalidade === '' ||
      this.props.dadosPessoais.nacionalidade === 'Brasileira'
    ) {
      return ValidationService.validate(this.props, validationBrazilian);
    } else {
      return ValidationService.validate(this.props, validationForeign);
    }
  };

  async componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.DataDocument.title);
    let orgaos = await this.props.orgaosExpedidoresBuscar();
    this.props.ufBuscar();
    this.handleChange('emissao', this.props.dadosPessoais.nascimento);

    orgaos
      .filter((p) => p.nacionalidade === this.props.dadosPessoais.nacionalidade)
      .map((orgaoExpedidor, indice) => {
        return this.handleChange('orgaoExpedidor', orgaoExpedidor.nome);
      });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    if (!this.formIsValid()) return;

    let chave = this.props.chave;
    this.props.dadosDocumentoAdicionar({
      chave,
      ...this.props,
    });
  };

  handleChange = (prop, value) => {
    this.props.updateDadosDocumento({prop, value});
  };

  renderUF = () => {
    return (
      <div className="form-group">
        <label htmlFor="uf" className="form-label">
          UF
        </label>

        <Select
          className="select-input"
          isSearchable={true}
          isClearable={true}
          id="uf"
          name="uf"
          required
          styles={SelectStyles}
          noOptionsMessage={() => 'Nenhuma opção encontrada'}
          placeholder="Selecione..."
          value={
            this.props.uf
              ? {
                  label: this.props.uf,
                  value: this.props.uf,
                }
              : ''
          }
          onChange={(ev) => this.handleChange('uf', ev ? ev.value : '')}
          options={
            this.props.ufs &&
            this.props.ufs.map((uf, indice) => ({
              label: uf.nome,
              value: uf.nome,
              key: indice,
            }))
          }
        />
      </div>
    );
  };

  renderOrgaoEmissor = () => {
    return (
      <div className="form-group">
        <label htmlFor="orgaoExpedidor" className="form-label">
          Orgão Emissor
        </label>

        <Select
          className="select-input"
          isSearchable={true}
          isClearable={false}
          id="orgaoExpedidor"
          name="orgaoExpedidor"
          required
          styles={SelectStyles}
          noOptionsMessage={() => 'Nenhuma opção encontrada'}
          placeholder="Selecione..."
          value={
            this.props.orgaoExpedidor
              ? {
                  label: this.props.orgaoExpedidor,
                  value: this.props.orgaoExpedidor,
                }
              : ''
          }
          onChange={(ev) =>
            this.handleChange('orgaoExpedidor', ev ? ev.value : '')
          }
          options={this.props.orgaosExpedidores
            .filter(
              (p) => p.nacionalidade === this.props.dadosPessoais.nacionalidade,
            )
            .map((orgaoExpedidor, indice) => ({
              label: orgaoExpedidor.nome,
              value: orgaoExpedidor.nome,
              key: indice,
            }))}
        />
      </div>
    );
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Documento</p>}
        contentCustom={
          <form className="form" id="frm" onSubmit={this.handleSubmit}>
            <InputText
              id="numero"
              name="rg"
              maxLength="15"
              value={this.props.numero}
              onChange={(ev) => this.handleChange('numero', ev.target.value)}
              placeholder={
                this.props.dadosPessoais.nacionalidade === 'Estrangeira'
                  ? 'Número RNE/CRNM'
                  : 'Número RG'
              }
            />
            {this.props.dadosPessoais.nacionalidade !== 'Estrangeira'
              ? this.renderUF()
              : ''}
            {this.renderOrgaoEmissor()}
            <InputText
              id="emissao"
              name="emissao"
              type="tel"
              mask="99/99/9999"
              placeholder="Data de emissão"
            />
          </form>
        }
        contentButtons={
          <div className="div-data-document">
            <Footer
              backHandle={() => {
                this.props.redirectToEndDataRegistration();
              }}
              nextForm="frm"
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer, select}) => {
  const {chave, dadosDocumento, naturalidade, dadosPessoais} = customer;
  const {orgaosExpedidores, ufs} = select;
  return {
    chave,
    ...dadosDocumento,
    naturalidade,
    orgaosExpedidores,
    ufs,
    dadosPessoais,
  };
};

export default connect(mapStateToProps, {
  redirectToEndDataRegistration,
  redirectToDataResidential,
  dadosDocumentoAdicionar,
  updateDadosDocumento,
  orgaosExpedidoresBuscar,
  ufBuscar,
})(DataDocument);
